import {
    SalesChannel,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_YOUNG,
} from '@vfde-sails/constants';
import { useDispatch } from '../store';
import { setSalesChannel } from 'Container/App/slice';
import { createComponentById } from '@vfde-brix/ws10/core';
import { createOptionPicker } from '@vfde-brix/ws10/option-picker';
import { SALESCHANNEL_OPTION_PICKER_CONTAINER } from 'Container/App/constants';

const mountSalesChannelOptionPicker = () => {
    const dispatch = useDispatch();

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const salesChannel = target.value as Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG>;

        dispatch(setSalesChannel(salesChannel));
    };

    return createComponentById(createOptionPicker, SALESCHANNEL_OPTION_PICKER_CONTAINER, { onChange });
};

export default mountSalesChannelOptionPicker;
